import { graphql, Script, useStaticQuery } from "gatsby";
import "normalize.css";
import * as React from "react";
import { Helmet } from "react-helmet";
import { GlobalStyle } from "../styles/global-styles";
import { transformMenuData } from "../utils/transformMenuData";
import { BackToTop } from "./BackToTop";
import { CookieBanner } from "./CookieBanner";
import { Header } from "./Header/Header";
import { Footer } from "./common/Footer";

type LayoutProps = {
  transparentHeader: boolean;
  children?: React.ReactChildren;
};

export function Layout(props: LayoutProps): JSX.Element {
  const menuItems = useStaticQuery(graphql`
    fragment MenuItems on SanityMenuBuilderItem {
      titleOverride
      customLink
      linkDestination {
        id
        title
        slug {
          current
        }
      }
      _key
    }

    fragment NavItems on SanityNavigation {
      title
      _key
    }

    {
      sanitySiteSettings(_id: { eq: "siteSettings" }) {
        id
        navigation {
          _key
          title
          internalLink {
            slug {
              current
            }
          }
          customLink
          subNavigation {
            _key
            title
            description
            image {
              asset {
                gatsbyImageData(width: 300)
                altText
              }
            }
            columns {
              _key
              title
              links {
                _key
                title
                variant
                externalLink
                internalLink {
                  id
                  title
                  slug {
                    current
                  }
                }
              }
            }
          }
        }
        footerMenu1Items {
          ...MenuItems
        }
      }
    }
  `);

  const footerLinkSet1 = transformMenuData(menuItems.sanitySiteSettings?.footerMenu1Items);

  const { children } = props;
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap"
        />
      </Helmet>
      <Script id="hotjar" strategy="post-hydrate">
        {`
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:6503331,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `}
      </Script>
      <Script id="snitcher" strategy="post-hydrate">
        {`
            !function(e){"use strict";var t=e&&e.namespace;if(t&&e.profileId&&e.cdn){var i=window[t];if(i&&Array.isArray(i)||(i=window[t]=[]),!i.initialized&&!i._loaded)if(i._loaded)console&&console.warn("[Radar] Duplicate initialization attempted");else{i._loaded=!0;["track","page","identify","group","alias","ready","debug","on","off","once","trackClick","trackSubmit","trackLink","trackForm","pageview","screen","reset","register","setAnonymousId","addSourceMiddleware","addIntegrationMiddleware","addDestinationMiddleware","giveCookieConsent"].forEach((function(e){var a;i[e]=(a=e,function(){var e=window[t];if(e.initialized)return e[a].apply(e,arguments);var i=[].slice.call(arguments);return i.unshift(a),e.push(i),e})})),-1===e.apiEndpoint.indexOf("http")&&(e.apiEndpoint="https://"+e.apiEndpoint),i.bootstrap=function(){var t,i=document.createElement("script");i.async=!0,i.type="text/javascript",i.id="__radar__",i.setAttribute("data-settings",JSON.stringify(e)),i.src=[-1!==(t=e.cdn).indexOf("http")?"":"https://",t,"/releases/latest/radar.min.js"].join("");var a=document.scripts[0];a.parentNode.insertBefore(i,a)},i.bootstrap()}}else"undefined"!=typeof console&&console.error("[Radar] Configuration incomplete")}({
              "apiEndpoint": "radar.snitcher.com",
              "cdn": "cdn.snitcher.com",
              "namespace": "Snitcher",
              "profileId": "8436457"
            });
          `}
      </Script>
      <GlobalStyle />
      <Header navItems={menuItems.sanitySiteSettings?.navigation} />
      {children}
      <Footer links={footerLinkSet1} />
      <BackToTop />
      <CookieBanner />
    </>
  );
}
